import { ProjectTypeEnum } from "@/api/graphql/types"

export enum UserRoles {
	admin = "admin",
	investor = "investor",
	projectOwner = "projectOwner",
	energyProvider = "energyProvider",
	installer = "installer",
}

// These project types are all considered 'Bonds'
export const ProjectBondsTypes: ProjectTypeEnum[] = [
	ProjectTypeEnum.SolarShares,
	ProjectTypeEnum.Portfolio,
	ProjectTypeEnum.SolarBonds,
]

export enum Environment {
	production = "production",
	development = "development",
}

// Date constants
export const dateFormat = "dd-MM-yyyy"
export const apiDateFormat = "yyyy-MM-dd"

export const graphMinKwhRoundThreshold = 100

export const mapCoordinatesCenterOfNetherlands = {
	lat: "52.271044",
	lng: "5.519243",
}

// Company contact details
export const contact = {
	emailAddress: "support@zonhub.com",
}
